export default __webpack_public_path__ + "static/media/988.78481116.png";